<template>
  <div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>
    <v-container>
      <v-form ref="form">
        <v-row>
          <h2 class="pb-5">{{ this.pageTitle }}</h2>
        </v-row>

        <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        >
        <v-row>
              <v-col cols="4" sm="4" class="pb-n5">
                  <v-text-field
                      outlined
                      :label="this.$t('allbank.paymentdesc')"
                      type="text"
                      v-model="formData.recref"
                      :rules="[rules.required, rules.counter]"
                      maxlength='20'
                      dense
                  ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="4" class="pb-n5 mt-n8">
                  <v-text-field
                      outlined
                      :label="this.$t('miscpayrolllsitreport.paymentreference')"
                      type="text"
                      v-model="formData.othpaydet"
                      :rules="[rules.counter]"
                      maxlength='20'
                      dense
                  ></v-text-field>
              </v-col>
            </v-row>
        </v-container>

        <v-row>
          <div class="pt-5 pl-4">
            <v-btn color="warning" style="width: 100px" @click="backHandler">
              {{$t('button.back')}}
            </v-btn>
          </div>
          <div class="pt-5 pl-4">
            <v-btn color="warning" style="width: 100px" @click="exportHandler">
              {{$t('button.export')}}
            </v-btn>
          </div>
        </v-row>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";

import ErrorDialog from "../../../components/common/ErrorDialog";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: {
    parentObject: Object,
  },

  components: {
    "app-error": ErrorDialog,
    Loading
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
        counter: (value) => value.length != 20 || this.$t('reportsparam.counter20'),
        date: (value) => moment(value) >= moment() && moment(value) <= moment().add(45, 'days') || this.$t('reportsparam.datecannotlessthantodayorexceed45dys'),
      },
      pageTitle: 'Alliance-01',

      parameter: this.parentObject.parameter,
      id: this.parentObject.id,
      data: this.parentObject.data,
      formData: {
          recref: '',
          othpaydet: ''
        },
      fileHolder: null,
      file: null,

      paymentModeList: ['LIP', 'LSP','LGP'],
        bank: [
          {
            id: 1,
            bankcode: "PHBMMYKL",
            bankdesc: "AFFIN BANK BERHAD",
            bankgencode: 1
          },
          {
            id: 75,
            bankcode: "AIBBMYKL",
            bankdesc: "AFFIN ISLAMIC BANK BERHAD",
            bankgencode: 75
          },
          {
            id: 2,
            bankcode: "AGOBMYKL",
            bankdesc: "AGROBANK BERHAD",
            bankgencode: 2
          },		
          {
            id: 101,
            bankcode: "AGOBMY21",
            bankdesc: "AGROBANK SPI",
            bankgencode: 101
          },
          {
            id: 95,
            bankcode: "ALSRMYK1",
            bankdesc: "ALLIANCE ISLAMIC BANK MALAYSIA BERHAD",
            bankgencode: 95
          },
          {
            id: 3,
            bankcode: "RJHIMYKL",
            bankdesc: "AL RAJHI BANK (MALAYSIA) BERHAD",
            bankgencode: 3
          },
          {
            id: 94,
            bankcode: "MBAMMY21",
            bankdesc: "ALLIANCE INVESTMENT BANK BERHAD SPI",
            bankgencode: 94
          },
          {
            id: 76,
            bankcode: "MBAMMYKL",
            bankdesc: "ALLIANCE INVESTMENT BANK BERHAD CONVENTIONAL",
            bankgencode: 76
          },
          {
            id: 4,
            bankcode: "MFBBMYKL",
            bankdesc: "ALLIANCE BANK MALAYSIA BERHAD",
            bankgencode: 4
          },
          {
            id: 5,
            bankcode: "ARBKMYKL",
            bankdesc: "AMBANK (M) BERHAD",
            bankgencode: 5
          },
          {
            id: 39,
            bankcode: "AISLMYKL",
            bankdesc: "AMISLAMIC BANK (M) BERHAD",
            bankgencode: 39
          },
          {
            id: 6,
            bankcode: "BKKBMYKL",
            bankdesc: "BANGKOK BANK BERHAD",
            bankgencode: 6
          },
          {
            id: 7,
            bankcode: "BIMBMYKL",
            bankdesc: "BANK ISLAM MALAYSIA BERHAD",
            bankgencode: 7
          },
          {
            id: 53,
            bankcode: "BKRMMYKL",
            bankdesc: "BANK KERJASAMA RAKYAT MALAYSIA BERHAD",
            bankgencode: 53
          },
          {
            id: 8,
            bankcode: "BMMBMYKL",
            bankdesc: "BANK MUAMALAT (MALAYSIA) BERHAD ",
            bankgencode: 8
          },
          {
            id: 50,
            bankcode: "BNMAMYKL",
            bankdesc: "BANK NEGARA MALAYSIA",
            bankgencode: 50
          },
          {
            id: 9,
            bankcode: "BOFAMY2X",
            bankdesc: "BANK OF AMERICA (MALAYSIA) BERHAD",
            bankgencode: 9
          },
          {
            id: 10,
            bankcode: "BKCHMYKL",
            bankdesc: "BANK OF CHINA (MALAYSIA) BERHAD",
            bankgencode: 10
          },
          {
            id: 11,
            bankcode: "BOTKMYKX",
            bankdesc: "BANK OF TOKYO-MITSUBISHI UFJ",
            bankgencode: 11
          },
          {
            id: 13,
            bankcode: "BSNAMYK1",
            bankdesc: "BANK SIMPANAN NASIONAL BERHAD",
            bankgencode: 13
          },
          {
            id: 54,
            bankcode: "BSNAMY21",
            bankdesc: "BANK SIMPANAN NASIONAL SPI",
            bankgencode: 54
          },
          {
            id: 51,
            bankcode: "PEMBMYK1",
            bankdesc: "BANK PEMBANGUNAN MALAYSIA BERHAD",
            bankgencode: 51
          },
          {
            id: 52,
            bankcode: "PEMBMY21",
            bankdesc: "BANK PEMBANGUNAN MALAYSIA BERHAD SPI",
            bankgencode: 52
          },
          {
            id: 14,
            bankcode: "BNPAMYKL",
            bankdesc: "BNP PARIBAS MALAYSIA BERHAD",
            bankgencode: 14
          },
          {
            id: 55,
            bankcode: "BNPAMY21",
            bankdesc: "BNP PARIBAS MALAYSIA BHD SPI",
            bankgencode: 55
          },
          {
            id: 15,
            bankcode: "PCBCMYKL",
            bankdesc: "CHINA CONSTRUCTION BANK (MALAYSIA) BERHAD",
            bankgencode: 15
          },
          {
            id: 59,
            bankcode: "CAGAMYKL",
            bankdesc: "CAGAMAS BERHAD",
            bankgencode: 59
          },
          {
            id: 60,
            bankcode: "CAGAMY21",
            bankdesc: "CAGAMAS BERHAD SPI",
            bankgencode: 60
          },
          {
            id: 16,
            bankcode: "CIBBMYKL",
            bankdesc: "CIMB BANK BERHAD",
            bankgencode: 16
          },
          {
            id: 61,
            bankcode: "COIMMYKL",
            bankdesc: "CIMB Investment Bank",
            bankgencode: 61
          },
          {
            id: 62,
            bankcode: "COIMMY21",
            bankdesc: "CIMB Investment Bank SPI",
            bankgencode: 62
          },
          {
            id: 63,
            bankcode: "CTBBMYKL",
            bankdesc: "CIMB ISLAMIC BANK BERHAD",
            bankgencode: 63
          },
          {
            id: 17,
            bankcode: "CITIMYKL",
            bankdesc: "CITIBANK BERHAD",
            bankgencode: 17
          },
          {
            id: 64,
            bankcode: "CITIMYM1",
            bankdesc: "Citibank SPI",
            bankgencode: 64
          },
          {
            id: 18,
            bankcode: "DEUTMYKL",
            bankdesc: "DEUTSCHE BANK (M) BERHAD",
            bankgencode: 18
          },
          {
            id: 65,
            bankcode: "DEUTMY21",
            bankdesc: "DEUTSCHE BANK MALAYSIA BHD SPI",
            bankgencode: 65
          },
          {
            id: 67,
            bankcode: "EXMBMY21",
            bankdesc: "EXPORT-IMPORT BANK MALAYSIA BERHAD",
            bankgencode: 67
          },
          {
            id: 68,
            bankcode: "EXMB9999",
            bankdesc: "EXPORT-IMPORT BANK MALAYSIA BERHAD SPI",
            bankgencode: 68
          },
          {
            id: 20,
            bankcode: "HLBBMYKL",
            bankdesc: "HONG LEONG BANK BERHAD",
            bankgencode: 20
          },
          {
            id: 69,
            bankcode: "PERDMYK1",
            bankdesc: "HONG LEONG INVESTMENT BANK BHD",
            bankgencode: 69
          },
          {
            id: 70,
            bankcode: "HLIBMYKL",
            bankdesc: "HONG LEONG ISLAMIC BANK BERHAD",
            bankgencode: 70
          },
          {
            id: 21,
            bankcode: "HBMBMYKL",
            bankdesc: "HSBC BANK MALAYSIA BERHAD",
            bankgencode: 21
          },
          {
            id: 71,
            bankcode: "HMABMYKL",
            bankdesc: "HSBC AMANAH MALAYSIA BERHAD",
            bankgencode: 71
          },
          {
            id: 22,
            bankcode: "IIMBMYKL",
            bankdesc: "INDIA INTERNATIONAL BANK MALAYSIA BHD",
            bankgencode: 22
          },
          {
            id: 23,
            bankcode: "ICBKMYKL",
            bankdesc: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (MALAYSIA) BERHAD",
            bankgencode: 23
        },
        {
            id: 24,
            bankcode: "CHASMYKX",
            bankdesc: "JP MORGAN CHASE BANK BERHAD",
            bankgencode: 24
        },
        {
            id: 72,
            bankcode: "KAFBMYKL",
            bankdesc: "KAF INVESTMENT BANK BHD",
            bankgencode: 72
        },
        {
            id: 73,
            bankcode: "KAFBMY21",
            bankdesc: "KAF INVESTMENT BANK BHD SPI",
            bankgencode: 73
        },
        {
            id: 97,
            bankcode: "KKENMYK1",
            bankdesc: "KENANGA INVESTMENT BANK BHD",
            bankgencode: 97
        },
        {
            id: 98,
            bankcode: "KKENMY21",
            bankdesc: "KENANGA INVESTMENT BANK BHD SPI",
            bankgencode: 98
        },
        {
            id: 99,
            bankcode: "KWAPMYK1",
            bankdesc: "KUMPULAN WANG PERSARAAN DIPERBADANKAN (KWAP)",
            bankgencode: 99
        },
        {
            id: 77,
            bankcode: "KWSPMYK1",
            bankdesc: "KUMPULAN WANG SIMPANAN PEKERJA (KWSP)",
            bankgencode: 77
        },
        {
            id: 25,
            bankcode: "KFHOMYKL",
            bankdesc: "KUWAIT FINANCE HOUSE (MALAYSIA) BERHAD",
            bankgencode: 25
          },
          {
            id: 26,
            bankcode: "MBBEMYKL",
            bankdesc: "MALAYAN BANKING BERHAD",
            bankgencode: 26
          },
          {
            id: 80,
            bankcode: "MBISMYKL", 
            bankdesc: "MALAYAN ISLAMIC BERHAD",
            bankgencode: 80
          },
          {
            id: 78,
            bankcode: "MBEAMYKL", 
            bankdesc: "MAYBANK INVESTMENT BANK BHD",
            bankgencode: 78
          },
          {
            id: 79,
            bankcode: "MBEAMY21", 
            bankdesc: "MAYBANK INVESTMENT BANK BHD SPI",
            bankgencode: 79
          },
          {
            id: 37,
            bankcode: "AFBQMYKL",
            bankdesc: "MBSB BANK BERHAD",
            bankgencode: 37
          },
          {
            id: 81,
            bankcode: "MIDFMYK1",
            bankdesc: "MIDF AMANAH INVESTMENT",
            bankgencode: 81
          },
          {
            id: 82,
            bankcode: "MIDFMY21",
            bankdesc: "MIDF AMANAH INVESTMENT SPI",
            bankgencode: 82
          },
          {
            id: 27,
            bankcode: "MHCBMYKA",
            bankdesc: "MIZUHO CORPORATE BANK (MALAYSIA) BERHAD",
            bankgencode: 27
          },
          {
            id: 100,
            bankcode: "NBADMYKL",
            bankdesc: "NATIONAL BANK OF ABU DHABI",
            bankgencode: 100
          },
          {
            id: 29,
            bankcode: "OCBCMYKL",
            bankdesc: "OCBC BANK (MALAYSIA) BERHAD",
            bankgencode: 29
          },
          {
            id: 84,
            bankcode: "OABBMYKL",
            bankdesc: "OCBC AL-AMIN BANK BERHAD",
            bankgencode: 84
          },
          {
            id: 30,
            bankcode: "PBBEMYKL",
            bankdesc: "PUBLIC BANK BHD",
            bankgencode: 30
          },
          {
            id: 86,
            bankcode: "SMBBMYK1",
            bankdesc: "PUBLIC INVESTMENT BANK BHD",
            bankgencode: 86
          },
          {
            id: 87,
            bankcode: "PIBEMYK1",
            bankdesc: "PUBLIC ISLAMIC BANK BHD",
            bankgencode: 87
          },
          {
            id: 96,
            bankcode: "AMMBMYKL",
            bankdesc: "AMINVESTMENT BANK BHD",
            bankgencode: 96
          },
          {
            id: 49,
            bankcode: "AMMBMY21",
            bankdesc: "AMINVESTMENT BANK BHD SPI",
            bankgencode: 49
          },
          {
            id: 88,
            bankcode: "RHBMMYK1",
            bankdesc: "RHB INVESTMENT BANK",
            bankgencode: 88
          },
          {
            id: 31,
            bankcode: "RHBBMYKL",
            bankdesc: "RHB BANK BERHAD",
            bankgencode: 31
          },
          {
            id: 89,
            bankcode: "RHBAMYKL",
            bankdesc: "RHB ISLAMIC BANK BERHAD",
            bankgencode: 89
          },
          {
            id: 90,
            bankcode: "MSMEMYK1",
            bankdesc: "SME Bank",
            bankgencode: 90
          },
          {
            id: 91,
            bankcode: "MSMEMY21",
            bankdesc: "SME Bank - SPI",
            bankgencode: 91
          },
          {
            id: 32,
            bankcode: "SCBLMYKX",
            bankdesc: "STANDARD CHARTERED BANK (MALAYSIA) BERHAD",
            bankgencode: 32
          },
          {
            id: 92,
            bankcode: "SCSRMYKK",
            bankdesc: "STANDARD CHARTERED SAADIQ (MALAYSIA) BERHAD",
            bankgencode: 92
          },
          {
            id: 33,
            bankcode: "SMBCMYKL",
            bankdesc: "SUMITOMO MITSUI BANKING CORPORATION MALAYSIA BERHAD",
            bankgencode: 33
          },
          {
            id: 34,
            bankcode: "NOSCMYKL",
            bankdesc: "THE BANK OF NOVA SCOTIA BHD",
            bankgencode: 34
          },
          {
            id: 35,
            bankcode: "ABNAMYKL",
            bankdesc: "THE ROYAL BANK OF SCOTLAND BHD",
            bankgencode: 35
          },
          {
            id: 93,
            bankcode: "UOVBMY21",
            bankdesc: "UNITED OVERSEAS BANK (MALAYSIA) BERHAD SPI",
            bankgencode: 93
          },
          {
            id: 36,
            bankcode: "UOVBMYKL",
            bankdesc: "UNITED OVERSEAS BANK (MALAYSIA) BERHAD",
            bankgencode: 36
          },
        ],

      staffilterlist: [],
      staffaccount: [],
      companyaccount: [],
      psnpayroll: [],
      // titleData: this.parentObject.data.salexprecdetail[0].payoutcode,
      titleData: this.parentObject.data.salexprecdetail
        .map(item => item.payoutcode)
        .join(', ')
        .slice(0, 200),//change to take all payoutcode
      payrolldata: [],

      companyrecnum: "",
      paymentmode: null,
      bankcode: null,
      receivingbank: "",
      paymentref: "",
      paymentdesc: "",
      addr: "",
      filler: "",

      accErr: [],
      negErrMsg: [],
      salhdErr: [],
      gettotalAmt: [],

      currency: null,
      processedCount: null,
      successCount: null,
      errCount: null,
      exCount: null,
      errMsg: "",
      isErr: false,
      isEdit: this.parentObject.isEdit,
      loading: false,
    };
  },

  methods: {

    // getAllianceExportListHandler() {
    //   const vm = this
      
    //   this.$store.dispatch('get', {url: `/allisalexport/all/${this.$store.getters.userId}`})
    //   .then(res => {
    //     let dateHolder = vm.data.year + "-" + 
    //                      vm.padRJ(vm.data.month, 2) + "-" + 
    //                      vm.daysInMonth(vm.data.month, vm.data.year);
          
    //     let date = moment(dateHolder).format("YYYY-MM-DD");
    //     let payrolldataholder = res.data.rec;
    //     payrolldataholder = payrolldataholder.filter(e => e.poid == vm.data.salexprecdetail[0].payoutctrlid)

    //     payrolldataholder.forEach(function (o) {
    //       var existing = vm.payrolldata.filter(function (i) {
    //         return i.staffid === o.staffid;
    //       })[0];
    //       if (!existing || existing == undefined) {
    //         if (o.bankid) {
    //           if (moment(o.startdate).format('YYYY-MM-DD') <= date && date <= moment(o.enddate).format('YYYY-MM-DD')) {
    //                 vm.payrolldata.push(o);
    //           }
    //         } else {
    //           vm.payrolldata.push(o);
    //         }
    //       }
    //     });
        
    //     this.loadStaffFilter()
    //   })
    //   .catch(function (err) {
    //     vm.errMsg = err;
    //   });
    // },

    getAllianceExportListHandler() {
      // i refined the method , to take the full array , not just first array,index[0]
      // Also new Query method instead of old query
      const vm = this;
      vm.loading = true;

      const userId = this.$store.getters.userId;
      const year = vm.data.year;
      const month = vm.data.month;

      this.$store.dispatch('get', {
        url: `/allisalexport/all/${userId}/${year}/${month}`
      })
      .then(res => {
        // 1. Prepare the comparison date
        let dateHolder = `${vm.data.year}-${vm.padRJ(vm.data.month, 2)}-${vm.daysInMonth(vm.data.month, vm.data.year)}`;
        let date = moment(dateHolder).format("YYYY-MM-DD");

        // 2. Extract all payoutctrlid values
        const payoutCtrlIds = vm.data.salexprecdetail.map(e => e.payoutctrlid);

        // 3. Filter payroll data for all matching payoutctrlid
        let payrolldataholder = res.data.rec.filter(e => payoutCtrlIds.includes(e.poid));

        // 4. Add filtered & deduplicated entries to vm.payrolldata
        payrolldataholder.forEach(o => {
          const exists = vm.payrolldata.some(i => i.staffid === o.staffid && i.poid === o.poid);
          if (!exists) {
            if (o.bankid) {
              if (
                moment(o.startdate).format('YYYY-MM-DD') <= date &&
                date <= moment(o.enddate).format('YYYY-MM-DD')
              ) {
                vm.payrolldata.push(o);
              }
            } else {
              vm.payrolldata.push(o);
            }
          }
        });

        // 5. Continue with filtering
        this.loadStaffFilter();
      })
      .catch(err => {
        vm.loading = false;
        vm.isErr = true;
        vm.errMsg = err;
        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
      });
    },

    loadStaffFilter() {
      const vm = this;

      this.$store.dispatch('post', {url: `/stafffilter/${this.$store.getters.userId}`, payload: this.parameter})
        .then(res => {
            vm.staffilterlist = res.data.rec;
            let checkval = false;
            for (const key in this.parameter) {
              if (this.parameter[key] && key != 'pomth' && key != 'poyr') checkval = true
            }

            if (checkval) {
              vm.payrolldata = vm.payrolldata.filter((el) => {
                  return vm.staffilterlist.some((f) => {
                      return f.staffid === el.staffid;
                  });
              });
            } 
          vm.loading = false;
        })
        .catch(err => {
          vm.loading = false;
            vm.isErr = true;
            vm.errMsg = err;
            vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
        });
    },

    async getData() {
      const vm = this
      let body = []
      let holdpayment = []
      let dataholder = vm.payrolldata
      //let totalcount = 0
      let payrolldetail = this.filter(dataholder);
      let bankaccount = {}
      let paymentmode = ''
      let alternativeemail =''
      let hpno=''
  
      this.processedCount = dataholder.length;
      this.successCount = payrolldetail.length;
      this.errCount = dataholder.length - payrolldetail.length;
      this.currency = payrolldetail[0].exchratecode;

      payrolldetail.forEach(element => {
        //let bankcodeacc = ''
        //let bankcodeholder = vm.bank.find(e => e.id == element.bankid)
        //bankcodeholder == undefined ? bankcodeacc = '' : bankcodeacc = bankcodeholder.code

        let email = ''          
          if (element.bankid == '4') {
            paymentmode = 'LIP'
            bankaccount.bankcode = 'MFBBMYKL'
          } else {
            bankaccount = vm.bank.find(e => e.id == element.bankid)
            paymentmode = 'LGP'
          } 
  
          if (element.email != null) email = element.email
          if (element.alternativeemail != null) alternativeemail = element.alternativeemail
          if (element.hpno != null) hpno = element.hpno.split("-").join("")

        for (const key in element) {
          if (element[key] == null) element[key] = ''
        }

        // hpnoholder = element.hpno

        //let nameholder = element.accountname.slice(0, 20)

        body.push({
            "Payment Mode": paymentmode + '|',
            "Beneficiary Name":this.limitStringLength(element.accountname, 140) + '|', 
            "Beneficiary Account": this.limitStringLength(element.staffaccountno, 19)  + '|',
            "Beneficiary Bank Code": this.limitStringLength(bankaccount.bankcode, 8)  + '|',
            "Amount": element.netpay.toFixed(2) + '|',
            "Payment Description": vm.formData.recref + '|',
            "Payment Reference": vm.formData.othpaydet + '|',
            "Beneficiary New IC No":'' + '|',
            "Beneficiary Old IC No":'' + '|',
            "Beneficiary Business Registration":'' + '|',
            "Beneficiary Others":'' + '|',
            "Payment Advice Indicator":'' + '|',
            "Mobile Phone No": this.limitStringLength(hpno, 11)  + '|',
            "Beneficiary Email 1":this.limitStringLength(email, 40)  + '|',
            "Beneficiary Email 2": this.limitStringLength(alternativeemail, 40)  + '|',
            "Generic Payment Information": '' + '|',
            "Invoice Date 1": '' + '|',
            "Invoice Amount 1": '' + '|',
            "Payment Amount 1": '' + '|',
            "Payment Description 1": '' + '|',
            "Invoice Date 2": '' + '|',
            "Invoice Amount 2": '' + '|',
            "Payment Amount 2": '' + '|',
            "Payment Description 2": '' + '|',
            "Invoice Date 3": '' + '|',
            "Invoice Amount 3": '' + '|',
            "Payment Amount 3": '' + '|',
            "Payment Description 3": '' + '|',
            "Invoice Date 4": '' + '|',
            "Invoice Amount 4": '' + '|',
            "Payment Amount 4": '' + '|',
            "Payment Description 4": '' + '|',
            "Invoice Date 5": '' + '|',
            "Invoice Amount 5": '' + '|',
            "Payment Amount 5": '' + '|',
            "Payment Description 5": '' + '|',
            "Invoice Date 6": '' + '|',
            "Invoice Amount 6": '' + '|',
            "Payment Amount 6": '' + '|',
            "Payment Description 6": '' + '|',
            "Invoice Date 7": '' + '|',
            "Invoice Amount 7": '' + '|',
            "Payment Amount 7": '' + '|',
            "Payment Description 7": '' + '|',
            "Invoice Date 8": '' + '|',
            "Invoice Amount 8": '' + '|',
            "Payment Amount 8": '' + '|',
            "Payment Description 8": '' + '|',
            "Invoice Date 9": '' + '|',
            "Invoice Amount 9": '' + '|',
            "Payment Amount 9": '' + '|',
            "Payment Description 9": '' + '|',
            "Invoice Date 10": '' + '|',
            "Invoice Amount 10": '' + '|',
            "Payment Amount 10": '' + '|',
            "Payment Description 10": '' + '|',
            "Batch Reference No.": '' + '|',
            "Payment Date": '' + '|',
            "Beneficiary Address": '' ,


        });

        holdpayment.push(element.netpay)
      });


      if (holdpayment) {
        let totalAmt = holdpayment.reduce(function (a, b) {return a + b}, 0);
        this.gettotalAmt = totalAmt.toFixed(2);
      }

        
      if (body.length > 0) {
        const txtData = this.objectToTxt(body);
        this.download(txtData, "Alliance_" + this.titleData);
      }
    },

    filter(item) {
      let checkacc = this.accfilter(item)
      let checkaccbank = this.accBankfilter(checkacc)
      let checkapaymentmethod = this.paymentmethodfilter(checkaccbank)
      let checkactive = this.activefilter(checkapaymentmethod)
      let checkpayment = this.paymentfilter(checkactive)
      return checkpayment
    },

    accfilter(item) {
      let data = item.filter(e => e.bankid)
      let noacc = item.filter((e) => !data.includes(e));
      for (let i = 0; i < noacc.length; i++) {
        noacc[i].errormsg = this.$t('allbank.noaccfound');
        this.accErr.push(noacc[i]);
      }
      return data
    },

    accBankfilter(item) {
      let data = item.filter(e => {
        for (let i = 0; i < this.bank.length; i++) {
          if (this.bank[i].id == e.bankid) return e
        }
      })
      let noaccbank = item.filter((e) => !data.includes(e));
      for (let i = 0; i < noaccbank.length; i++) {
        noaccbank[i].errormsg = this.$t('allbank.bankaccnotinlist');
        this.accErr.push(noaccbank[i]);
      }
      return data
    },

    paymentmethodfilter(item) {
      let data = item.filter(e => e.paymodecode == 'BANK');
      let diffpayment = item.filter((e) => !data.includes(e));
      for (let i = 0; i < diffpayment.length; i++) {
        diffpayment[i].errormsg = this.$t('allbank.differentpaymentmethod');
        this.accErr.push(diffpayment[i]);
      }
      return data
    },

    activefilter(item) {
      let data = item.filter(e => e.pystatcode == 'ACTIVE')
      let notactive = item.filter((e) => !data.includes(e));
      for (let i = 0; i < notactive.length; i++) {
        notactive[i].errormsg = this.$t('setupreport_exportmapping.paymentisnotactive');
        this.accErr.push(notactive[i]);
      }
      return data
    },

    paymentfilter(item) {
      let data = item.filter(e => e.netpay > 0)
      let nopayment = item.filter((e) => !data.includes(e));
      for (let i = 0; i < nopayment.length; i++) {
        nopayment[i].errormsg = this.$t('setupreport_exportmapping.nopayment');
        this.accErr.push(nopayment[i]);
      }
      return data
    },

    objectToTxt(data) {
      const csvRows = [];
      const dataheaders = Object.keys(data[0]);

      //csvRows.push(header);
      //csvRows.push(batchheader);

      //loop over the rows
      for (const row of data) {
        const values = dataheaders.map((header) => {
          const escaped = ("" + row[header]).replace(/"/g, '\\"');
          return `${escaped}`;
        });
        csvRows.push(values.join(""));
      }
      return csvRows.join("\n");
    },

    download(data, title) {
      // const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text" });
      const blob = new Blob([data], { type: "text/plain;charset=utf-8" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", title + ".txt");

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    padRJ(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },

    padLJ(num, size) {
      var s = num + "";
      while (s.length < size) s = s + "0";
      return s;
    },

    padSpaceRJ(char, size) {
      var s = char + "";
      while (s.length < size) s = " " + s;
      return s;
    },

    padSpaceLJ(char, size) {
      var s = char + "";
      while (s.length < size) s = s + " ";
      return s;
    },

    limitStringLength(string, maxLength) {
          // Check if the length of the string exceeds the maximum length
          if (string.length > maxLength) {
              // If it does, truncate the string to the specified maximum length
              return string.slice(0, maxLength);
          } else {
              // If not, return the original string
              return string;
          }
      },

    exportHandler() {
      if (!this.$refs.form.validate()) {
        this.isErr = true;
        this.errMsg = this.$t('vdatatable.someinfoismissing');
      } else {
        this.getData();
        let item = [];
        item.totalAmt = this.gettotalAmt;
        item.accounterr = this.accErr;
        item.negErrMss = this.negErrMsg;
        item.successCount = this.successCount;
        item.processedCount = this.processedCount;
        item.errCount = this.errCount;
        item.currency = this.currency;
        this.$router.push({ name: "salaryexportlog", params: { item } });
      }
    },

    backHandler() {
      let param = this.parameter

      this.$router.push({ name: "salaryexport", params: { param } });
    },

    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
  },

  mounted() {
    this.getAllianceExportListHandler();
  },
};
</script>